import { isNode } from "browser-or-node";
import fetch from "cross-fetch";
import { nanoid } from "nanoid";
const endpoint = "https://api.superwall.dev";
class SWEventsClient {
    apiKey;
    _requestId;
    _hostname;
    _release;
    configure(apiKey, { requestId } = {}) {
        this.apiKey = apiKey;
        this._requestId = requestId;
    }
    requestId(requestId) {
        const newClient = new SWEventsClient();
        newClient.configure(this.apiKey || undefined, {
            requestId
        });
        return newClient;
    }
    async capture(name, event, metadata = {}) {
        const baseEvent = {
            id: nanoid(),
            ts: new Date().toISOString(),
            metadata: {
                ...metadata,
                ...isNode ? {
                    hostname: this._hostname,
                    release: this._release
                } : {}
            }
        };
        // We have to ignore here b/c I couldn't get tsc to figure
        // out that the event is a narrowed type ofTSWEvent
        //@ts-ignore
        return this.publish([
            //@ts-ignore
            {
                ...baseEvent,
                name,
                event
            }
        ]);
    }
    async captureMany(events) {
        return this.publish(//@ts-ignore
        events.map((e)=>({
                ...e,
                id: nanoid(),
                ts: new Date().toISOString(),
                metadata: {}
            })));
    }
    async publish(events) {
        const resolvedEndpoint = process.env.NEXT_PUBLIC_SWEVENTS_ENDPOINT || endpoint;
        const url = `${resolvedEndpoint}/api/internal/events`;
        const result = await fetch(url, {
            // https://stackoverflow.com/questions/40523469/navigator-sendbeacon-to-pass-header-information
            keepalive: true,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.apiKey}`
            },
            body: JSON.stringify({
                events
            })
        }).then((r)=>r.json()).catch((e)=>{
        // console.error(`[SWEventsClient] Error publishing event: ${e}, ${e.body}`)
        });
        // console.log(
        //   `[SWEventsClient] Published event: ${JSON.stringify(events)}, result: ${JSON.stringify(
        //     result
        //   )}`
        // )
        return result;
    }
}
export { SWEventsClient };
